<template>
  <div class="newscreeen">
    <img class="logo" src="@/assets/newscreen/logo.png" />
    <viewer v-model="showImage" :src="Gongyitu"></viewer>

    <nheader>
      <img class="top-title" src="@/assets/newscreen/top-title.png" />
    </nheader>
    <div class="zongbox zongboxl">
      <div class="modulex">
        <nmodule title="今日热点数据" link="/chome/siteDetection">
          <hotDataToday :siteList="siteList" :countObj="countObj"></hotDataToday>
        </nmodule>
      </div>
      <div class="modulex">
        <nmodule title="运行完好率" link="/chome/onlineData">
          <div slot="control" class="select">
            <SelectZ :data="dateEnum" :placeholder="dateEnum[0].name" @change="selectDate($event)"></SelectZ>
          </div>
          <wasteGas ref="wasteGasRef"></wasteGas>
        </nmodule>
      </div>
      <div class="modulex">
        <nmodule title="废水在线" link="/chome/siteDetection?siteMn=008&siteId=9">
          <wasteWater :wushuiList="wushuiList"></wasteWater>
        </nmodule>
      </div>
    </div>
    <div class="zongbox zongboxc">
      <centerTemp ref="centerRef" :centerAllData="centerAllData" @showPic="showImage = true"></centerTemp>
    </div>
    <div class="zongbox zongboxr">
      <div class="modulex">
        <nmodule title="环境气象" link="/chome/siteDetection?siteMn=009&siteId=10">
          <div class="atmosphereBox">
            <div class="rowBox">
              <div class="background"></div>
              <div class="row">
                <span class="label">温度</span>
                <span class="value">{{ temperature }}</span>
              </div>
              <div class="row">
                <span class="label">风向</span>
                <span class="value">{{ windDirection }}</span>
              </div>
            </div>
            <div class="rowBox">
              <div class="background"></div>
              <div class="row">
                <span class="label">湿度</span>
                <span class="value">{{ humidity }}</span>
              </div>
              <div class="row">
                <span class="label">pm2.5</span>
                <span class="value">{{ pm25 }}</span>
              </div>
            </div>
            <div class="rowBox">
              <div class="background"></div>
              <div class="row">
                <span class="label">风速</span>
                <span class="value">{{ windSpeed }}</span>
              </div>
              <div class="row">
                <span class="label">pm10</span>
                <span class="value">{{ pm10 }}</span>
              </div>
            </div>

          </div>
        </nmodule>
      </div>
      <div class="modulex">
        <nmodule title="噪声在线" link="/chome/siteDetection?siteMn=009&siteId=10">
          <noticeOnline :changjieList="changjieList"></noticeOnline>
        </nmodule>
      </div>
      <div class="modulex">
        <nmodule title="危废库存" link="/waste/statistics">
          <!-- <div slot="control">
            <Icon type="md-arrow-dropleft" @click="lastPage"
              :style="{ color: this.pageOption.current === 1 ? '#888' : '#00ecfb', 'font-size': '1.5rem' }" />
            <Icon type="md-arrow-dropright" @click="nextPage"
              :style="{ color: this.pageOption.current >= Math.ceil(this.pageOption.total / this.pageOption.page) ? '#888' : '#00ecfb', 'font-size': '1.5rem' }" />
          </div> -->
          <dangerHub @loadok="loadRight" ref="dhRef"></dangerHub>
        </nmodule>
      </div>
      <div class="modulex">
        <nmodule title="危废进出量" link="/waste/recordsCount">
          <!-- <div slot="control">
            <div class="control-tool">
              <div class="circle-item">
                <div class="circle circle1"></div>入
              </div>
              <div class="circle-item">
                <div class="circle circle2"></div>出
              </div>
            </div>
          </div> -->
          <inoutCount></inoutCount>
        </nmodule>
      </div>
    </div>
    <gongyitu></gongyitu>
    <countdialog></countdialog>
  </div>
</template>

<script>
import nheader from '../newhome/nheader.vue';
import ntitle from '../newhome/ntitle.vue';
import nmodule from '../newhome/nmodule.vue';
import centerTemp from '../newhome/center/center.vue';
import wasteGas from '../newhome/right/wasteGasSp.vue';
import wasteWater from '../newhome/right/wasteWater.vue';
import noticeOnline from '../newhome/right/noticeOnline.vue';
//left
import dangerHub from '../newhome/left/dangerHub.vue';
import hotDataToday from '../newhome/left/hotDataToday.vue';
import inoutCount from '../newhome/left/inoutCount.vue';
import gongyitu from '../newhome/dialog/gongyitu.vue';
import countdialog from '../newhome/dialog/countdialog.vue';

import VueViewer from '@/components/picView.vue'
import 'viewerjs/dist/viewer.css'
import Gongyitu from '@/assets/newscreen/WechatIMG1019.png'
import SelectZ from "../components/select.vue"; // 园区平台下拉框

export default {
  components: {
    nheader,
    ntitle,
    nmodule,
    centerTemp,
    wasteGas,
    wasteWater,
    noticeOnline,
    dangerHub,
    hotDataToday,
    inoutCount,
    gongyitu,
    countdialog,
    viewer: VueViewer,
    SelectZ
  },
  data() {
    return {
      Gongyitu,
      showImage: false,
      pageOption: {
        current: 1,
        total: 0,
        page: 0
      },
      siteList: [],
      // 设备数据
      changjieList: [],
      guoluList: [],
      wushuiList: [],
      centerAllData: [],
      countObj: {},
      timer: null,
      windSpeed: 0,
      windDirection: 0,
      temperature: 0,
      humidity: 0,
      pm25: 0,
      pm10: 0,
      dateEnum: [
        {
          name: "月完好率",
          value: "ofMonth",
          id: 1
        },
        {
          name: "季完好率",
          value: "ofQuarter",
          id: 2
        },
        {
          name: "年完好率",
          value: "ofYear",
          id: 3
        }
      ],
    }
  },
  mounted() {
    this.pageDataInit()
    // this.getWeather()
    this.selectDate('ofMonth')
    // 设备完好率
    this.chartsInit2();
    this.timer = setInterval(() => {
      this.pageDataInit();
      // this.getWeather()
    }, 60 * 1000)
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getWindDirection(angle) {
      const adjustedAngle = angle % 360;
      const directionRanges = [
        { start: -22.5, end: 22.5, name: "北" },
        { start: 22.5, end: 67.5, name: "东北偏北" },
        { start: 67.5, end: 112.5, name: "东北" },
        { start: 112.5, end: 157.5, name: "东南偏东" },
        { start: 157.5, end: 202.5, name: "东南" },
        { start: 202.5, end: 247.5, name: "西南偏南" },
        { start: 247.5, end: 292.5, name: "西南" },
        { start: 292.5, end: 337.5, name: "西北偏西" },
        { start: 337.5, end: 360, name: "西北" },
        // 以下为循环回到起点，为了完整性而列出
        { start: -202.5, end: -157.5, name: "西南偏西" },
        { start: -157.5, end: -112.5, name: "西南" },
        { start: -112.5, end: -67.5, name: "东南偏西" },
        { start: -67.5, end: -22.5, name: "东南" },
        { start: -337.5, end: -292.5, name: "西北偏北" },
        { start: -292.5, end: -247.5, name: "西北" },
        { start: -247.5, end: -202.5, name: "西南偏北" },
      ];
      for (const dir of directionRanges) {
        if (adjustedAngle >= dir.start && adjustedAngle < dir.end) {
          return dir.name;
        }
      }
    },
    getWeather(res) {
      // this.$api.Park.getWeather(null, ["uuids", "park"]).then(res => {
      res.data.forEach(item => {
        if (item.remark.includes('风速')) {
          if (item.remark.includes('-1') && item.currentValue) {
            this.windSpeed = item.currentValue + item.unit
          }
          if (!this.windSpeed && item.remark.includes('-2')) {
            this.windSpeed = item.currentValue + item.unit
          }
        }

        if (item.remark.includes('风向')) {
          if (item.remark.includes('-1') && item.currentValue) {
            this.windDirection = this.getWindDirection(item.currentValue)
          }

          if (!this.windDirection && item.remark.includes('-2')) {
            this.windDirection = this.getWindDirection(item.currentValue)
          }
        }

        if (item.remark.includes('pm2.5')) {
          if (item.remark.includes('-1') && item.currentValue) {
            this.pm25 = item.currentValue + item.unit
          }
          if (!this.pm25 && item.remark.includes('-2')) {
            this.pm25 = item.currentValue + item.unit
          }
        }

        if (item.remark.includes('温度')) {
          if (item.remark.includes('-1') && item.currentValue) {
            this.temperature = item.currentValue + item.unit
          }
          if (!this.temperature && item.remark.includes('-2')) {
            this.temperature = item.currentValue + item.unit
          }
        }

        if (item.remark.includes('湿度')) {
          if (item.remark.includes('-1') && item.currentValue) {
            this.humidity = item.currentValue + item.unit
          }
          if (!this.humidity && item.remark.includes('-2')) {
            this.humidity = item.currentValue + item.unit
          }
        }

        if (item.remark.includes('pm10')) {
          if (item.remark.includes('-1') && item.currentValue) {
            this.pm10 = item.currentValue + item.unit
          }
          if (!this.pm10 && item.remark.includes('-2')) {
            this.pm10 = item.currentValue + item.unit
          }
        }

      })
      // })
    },
    pageDataInit() {
      this.$api.Park.getAccessWarnCount(null, ["uuids", "park"]).then(res => {
        let data = res.data;
        let warnCount = data.warnCount["康盛"] || data.warnCount["康盛股份"] || data.warnCount["康盛科工贸"] || 0;
        let shutDownCount = data.shutDownCount["康盛"] || data.shutDownCount["康盛股份"] || data.shutDownCount["康盛科工贸"] || 0;
        let ventCount = data.ventCount["康盛"] || data.ventCount["康盛股份"] || data.ventCount["康盛科工贸"] || 0;
        this.countObj = {
          warnCount,
          shutDownCount,
          ventCount
        }
      });
      // this.getSite();
      // this.getScreenDat();
      //获取噪声废气数据
      this.getDeviceData();
      //获取总排放量
      this.getPaifangAll();
    },

    // 按时间 查完好率
    selectDate(e) {
      this.third_select = e;
      // 重发socket信息
      // let socket = this.getSocket;
      // let obj = {};
      // obj[e] = true;
      // this.$store.commit("setSocketParmas", {
      //   siteDeviceIntactRate: obj
      // });
      // if (socket) {
      //   socket.send("subscrip", {
      //     siteDeviceIntactRate: obj
      //   });
      // }
      this.chartsInit2();
    },
    chartsInit2() {
      this.getDeviceIntact().then(res => {
        if (res.code == 0) {
          let dataList = res.data;
          this.$refs.wasteGasRef.initDraw(dataList)
        } else {
          this.$Notice.warning({
            title: "左三图表初始化失败",
            desc: res.message || "请联系管理员"
          });
          return false;
        }
      });
    },
    // 获取设备完好率
    getDeviceIntact() {
      return new Promise((resovle, reject) => {
        let param = {
          content: {}
        };
        if (this.third_select) param.content[this.third_select] = true;
        this.$api.Park.getDeviceIntact(param, ["uuids", "park"]).then(res => {
          resovle(res);
        });
      });
    },

    getPaifangAll() {
      this.$api.Deploy.getAggregationLog({}, ["uuid", "company"]).then(res => {
        this.centerAllData = [null,null,null]
        res.data.forEach(item=>{
          if(item.dataTypeName == "化学需氧量"){
            this.centerAllData[0] = item
          }
          if(item.dataTypeName == "氨氮"){
            this.centerAllData[1] = item
          }
          if(item.dataTypeName == "流量"){
            this.centerAllData[2] = item
          }
        })
        console.log(this.centerAllData)
      })
    },
    getDeviceData() {
      this.$api.Park.getRTUAllData({
        ids: "1,2,3,4,5,13,21,43"
      }, ["uuid", "park"]).then(res => {
        this.changjieList = [];
        this.guoluList = [];
        this.wushuiList = [];
        let data = res.data;
        let changjieObj = {};
        let guoluObj = {};
        let wushuiObj = {};
        this.getWeather(res)
        for (let i = 0; i < data.length; i++) {
          if (data[i].remark.indexOf("炉") !== -1) {
            // 噪声
            if (!guoluObj[data[i].remark]) {
              guoluObj[data[i].remark] = {
                remark: data[i].remark
              }
              guoluObj[data[i].remark][data[i].name] = data[i];
            } else {
              guoluObj[data[i].remark][data[i].name] = data[i];
            }
          } else if (data[i].remark.indexOf("污水") !== -1) {
            if (!wushuiObj[data[i].remark]) {
              wushuiObj[data[i].remark] = {
                remark: data[i].remark
              }
              wushuiObj[data[i].remark][data[i].remark.trim()] = data[i];
            } else {
              wushuiObj[data[i].remark][data[i].remark.trim()] = data[i];
            }
          } else {
            // 锅炉
            if (!changjieObj[data[i].remark]) {
              changjieObj[data[i].remark] = {
                remark: data[i].remark
              }
              changjieObj[data[i].remark][data[i].remark] = data[i];
            } else {
              changjieObj[data[i].remark][data[i].remark] = data[i];
            }
          }
        }
        for (let item in changjieObj) {
          this.changjieList.push(changjieObj[item])
        }
        for (let item in guoluObj) {
          this.guoluList.push(guoluObj[item])
        }
        for (let item in wushuiObj) {
          this.wushuiList.push(wushuiObj[item])
        }
        console.log('guoluList', this.guoluList)

        this.$api.Park.getSiteCount(null, ["uuids", "park"]).then(res => {
          res.data = {
            "车间一": 65.21,
            "车间二": 43.41,
            "车间三": 43.41,
            "车间四": 29.35,
            "车间五": 43.41,
            "车间六": 43.41,
            "车间七": 29.35,
          }
          // this.$refs.wasteGasRef.initDraw(res.data)
        });


      })
    },
    getScreenDat() {
      return this.$api.Deploy.getScreenCountD({
        ids: "1,2,3,4,5,6,7"
      }, ["uuid", "park"]).then(res => {
        //console.log(res)
      })
    },
    getSite() {
      return this.$api.Deploy.getSiteList(
        {
          pageCurrent: 1,
          pageSize: 50
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          this.siteList = res.data.list;
          // this.$refs.centerRef.drawMarker(this.siteList);
        } else {
        }
      });
    },
    loadRight(data) {
      this.pageOption.total = data.total;
      this.pageOption.page = data.page;
    },
    lastPage() {
      if (this.pageOption.current === 1) {
        return
      } else {
        this.pageOption.current--;
        this.$refs.dhRef.goPage(this.pageOption.current);
      }
    },
    nextPage() {
      if (this.pageOption.current >= Math.ceil(this.pageOption.total / this.pageOption.page)) {
        return
      } else {
        this.pageOption.current++;
        this.$refs.dhRef.goPage(this.pageOption.current);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.atmosphereBox {
  // padding: min(0.5rem, 5px) 0;
  box-sizing: border-box;
  height: 80%;
  width: 90%;
  margin-left: 5%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .rowBox {
    width: 100%;
    height: calc(100% / 3);
    display: flex;
    position: relative;
    .background {
      position: absolute;
      width: 100%;
      height: 60%;
      top: 40%;
      background: linear-gradient(to bottom, rgba(7, 56, 125, 0), rgba(7, 56, 125, 1));
      z-index: 1;
      transform: skew(30deg);
    }

    .row {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      z-index: 50;

      .label {
        font-size: 1.07rem;
        color: #FFFFFF;
        line-height: 1.5rem;
        grid-area: 'label';
      }

      .value {
        font-size: 1.07rem;
        background: linear-gradient(90deg, #FAFEF6 0%, #55CF6B 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: 1.5rem;
        grid-area: 'value';
        text-align: left;
      }

    }
  }
}

.newscreeen {
  background: #0a2669;
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/newScreenBac.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .logo {
    position: absolute;
    top: 2.2rem;
    left: 3rem;
    max-width: 10rem;
    max-height: 3vh;
    z-index: 1;
  }

  .top-title {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 100;
    width: 32%;
    transform: translateY(-98%);
  }

  .zongbox {
    position: absolute;
  }

  .zongboxl {
    left: 1rem;
    top: 8vh;
    width: 28%;
    height: calc(100% - 8vh);
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 0.24fr 0.375fr 0.375fr;
    grid-gap: min(1rem, 5px);
  }

  .zongboxr {
    right: 1rem;
    top: 8vh;
    width: 28%;
    height: calc(100% - 8vh);
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 0.18fr 0.26fr 0.35fr 0.25fr;
    grid-gap: min(1rem, 5px);
  }

  .zongboxc {
    left: 50%;
    top: 10vh;
    transform: translateX(-50%);
    width: 40%;
    height: calc(100% - 10vh - 1rem);
    // grid
  }

  .modulex {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .select {
      margin-right: 12%;
      width: 6rem;
      // height: 80%;
      line-height: 1.6rem;
      margin-top: 3px;
      font-size: 1rem;
    }
  }
}

.control-tool {
  display: flex;

  .circle-item {
    margin-left: 0.5em;
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }

  .circle {
    width: 0.875rem;
    height: 0.875rem;
    background: red;
    border-radius: 50%;
    margin-right: 0.5rem;
  }

  .circle1 {
    background-image: linear-gradient(180deg, #8EE6FF 0%, #CBF3FF 100%);
  }

  .circle2 {
    background-image: linear-gradient(180deg, #C67F00 0%, #FFF7F2 100%);
  }

  .circle3 {
    background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.60) 100%);
  }
}

@media screen and (min-height: 1080px) {
  .newscreeen {

    // .zongboxl {
    //     grid-template-rows: 0.275fr 0.3625fr 0.3625fr !important;
    // }
    .zongboxr {
      grid-template-rows: 0.18fr 0.26fr 0.35fr 0.25fr !important;
    }
  }
}

@media screen and (max-height: 1080px) {
  .newscreeen {

    // .zongboxl {
    //     grid-template-rows: 0.275fr 0.3625fr 0.3625fr !important;
    // }
    .zongboxr {
      grid-template-rows: 0.18fr 0.26fr 0.35fr 0.25fr !important;
    }
  }
}

@media screen and (max-height: 970px) {
  .newscreeen {
    .zongboxl {
      grid-template-rows: 0.275fr 0.4fr 0.325fr !important;
    }

    .zongboxr {
      grid-template-rows: 0.18fr 0.26fr 0.35fr 0.25fr !important;
    }
  }
}

@media screen and (max-height: 930px) {
  .newscreeen {
    .zongboxr {
      grid-template-rows: 0.18fr 0.26fr 0.35fr 0.25fr !important;
    }
  }
}

@media screen and (max-height: 910px) {

  .newscreeen {
    .zongboxl {
      grid-template-rows: 0.3fr 0.4fr 0.325fr !important;
    }

    .zongboxr {
      grid-template-rows: 0.18fr 0.26fr 0.35fr 0.25fr !important;
    }
  }
}
</style>